"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getStyles = utilities_1.memoizeFunction(function (theme, customStyles) {
    if (!theme) {
        theme = styling_1.getTheme();
    }
    var DefaultStyles = {
        root: {},
        editor: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center"
        },
        editors: {
            marginBottom: 8
        },
        nameField: {
            marginRight: 8,
            width: "30%"
        },
        urlField: {
            marginLeft: 8,
            width: "50%"
        },
        removeAction: {
            marginLeft: 8
        },
        actions: {}
    };
    return styling_1.concatStyleSets(DefaultStyles, customStyles);
});
exports.getStyles = getStyles;
